import { PATHS } from 'config/routes'
import { mobilePageTitleAtom } from 'config/store'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import arrowNextIcon from 'assets/images/arrow-next-white.svg'
import changeAvaIcon from 'assets/images/profilemobile-changeava.svg'
import editInfoIcon from 'assets/images/profilepage-editInfo.svg'
import { useQuery } from 'react-query'
import { getUserInfoQuery } from 'dataLayer/game'

function UserInfoMobile({ title }) {
	const { t } = useTranslation()

	const { data: userInfo } = useQuery(getUserInfoQuery())

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Container fluid className="userinfo-mobile-container px-0">
			<Row className="userinfo-mobile-detail mt-3">
				<div className="title">{t('mobile.my_acc.basic_info')}</div>
				{/* <div>
					<p>{t('mobile.my_acc.ava')}</p>
					<div className="edit-btn">
						<Link to={PATHS.SELECT_AVA}>
							<p>{t('mobile.my_acc.change_ava')}</p>
							<img src={changeAvaIcon} alt="Change user's avatar" />
						</Link>
					</div>
				</div> */}
				<div>
					<p>{t('mobile.my_acc.name')}</p>
					<div className="edit-btn">
						<p>{userInfo?.displayName}</p>
						<Link to={PATHS.CHANGE_INFO}>
							<img
								src={editInfoIcon}
								width="26"
								height="26"
								alt="Change user's infomation"
							/>
						</Link>
					</div>
				</div>
				<div>
					<p>{t('mobile.my_acc.phone')}</p>
					<span>{userInfo?.msisdn}</span>
				</div>
				{/* <div>
					<p>{t('mobile.my_acc.ref')}</p>
					<span>{userInfo?.referralCode}</span>
				</div> */}
			</Row>
			{/* <Row className="userinfo-mobile-changepass mt-3">
				<Link to={PATHS.CHANGE_PASS}>
					{t('profile.sidebar.change_pass')}
					<img src={arrowNextIcon} alt="" />
				</Link>
			</Row> */}
		</Container>
	)
}

export default UserInfoMobile
